import React, { useEffect, useState } from "react";
import "./loginform.css";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../shared";
import axios from "axios";
import { setGlobalState, useGlobalState } from "../state/index";
import { useAuth } from "./useAuth";
import { useLocation } from 'react-router-dom';

const Timestamp = ({ date }) => {
  const options = {
    weekday: 'long',   // Full weekday name (e.g., Friday)
    year: 'numeric',   // Full year (e.g., 2025)
    month: 'long',    // Full month name (e.g., April)
    day: '2-digit',   // Two-digit day (e.g., 04)
    hour: '2-digit',  // Two-digit hour (e.g., 08)
    minute: '2-digit',// Two-digit minute (e.g., 19)
    timeZoneName: 'short' // Timezone abbreviation (e.g., CST)
  };

  const formatter = new Intl.DateTimeFormat('en-US', options);
  return <div style={{
    fontSize:'11px'
  }}>{formatter.format(new Date(date))}</div>;
};

export default function ClassLink() {
  const [errorMessage, setErrorMessage] = useState("");
  const [errorDistrictMSG, setErrorDistrictMSG] = useState("");
  const [errorStudentMSG, setErrorStudentMSG] = useState("");
  const [errorDOBMSG, setErrorDOBMSG] = useState("");
  const [spinner, setSpinner] = useState(true);
  const [checkURL, setCheckURL] = useState(false);

  const [urlCode, setURLCode] = useState("");
  const [response_type, setResponse_type] = useState();

  const [day, setDay] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [userData, setUserData] = useState(null);
  const classLinkImg = require("../menu_icons/ClassLink.png");
  const explorerImg = require("../icons/Explorer.png");
  const classLink_Img = require("../menu_icons/ClassLinkImg.png");

  const [userId, setUserId] = useState();
  const [tenantId, setTenantId] = useState();
  const [tenant, setTenant] = useState();
  const [role, setRole] = useState();
  const [invalidCode, setInvalidCode] = useState(false);
  const [code, setCode] = useState();

  const navigate = useNavigate();
  const { login } = useAuth();
  const [currentDateTime, setCurrentDateTime] = useState(new Date());

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const paramscode = params.get("code");
    const response_type = params.get("response_type");
    const urlSEAccessReadOnly = params.get("seaccessreadonly");

    // Handle SEAccessReadOnly parameter
    if (urlSEAccessReadOnly) {
      const isReadOnly = urlSEAccessReadOnly.toLowerCase() === "true";
      setGlobalState("SEAccessReadOnly", isReadOnly);
      sessionStorage.setItem("SEAccessReadOnly", isReadOnly.toString());
    }

    if (paramscode) {
      setURLCode(paramscode);
      setResponse_type(response_type);
      setCheckURL(false);
    }
  }, []);

  useEffect(() => {
    if (urlCode) {
      setCheckURL(false);
      setSpinner(true);
      setCurrentDateTime(new Date());
      popup();
      setErrorMessage("");
    } else {
      setCheckURL(true);
      setSpinner(false);
    }
  }, [urlCode]);

  const location = useLocation();
  const fromLogout = location.state?.fromLogout === true;

  const popup = () => {
    const url = baseUrl + "api/Login/classlink_callback";
    sessionStorage.removeItem("ClassLinkLogin");
    if (urlCode) {
      axios
        .post(url + `?code=${urlCode}&loginTime=${currentDateTime.toLocaleString()}`)
        .then((result) => {
          const loginResult = result.data;
          console.log("ClassLink login result:", loginResult);

          if (
            Object.keys(result.data).includes("roleId") &&
            result.data.roleId != 4
          ) {
            setUserData(loginResult);
            setSpinner(false);
          }
          sessionStorage.setItem("ClassLinkLogin", result.data.authtoken);
          if (Object.keys(result.data).includes("error")) {
            setErrorMessage(result.data.error);
            setSpinner(false);
          } else if (Object.keys(result.data).includes("errorCode")) {
            setInvalidCode(true);
            setCode(result.data.code)
            setSpinner(false);
          }
          else if (
            loginResult &&
            loginResult.errorMsg !== "Student Code does not exist"
          ) {
            let DOB = "DOB";
            loginResult[DOB] = "";
            setGlobalState("authtoken", result.data.authtoken);
            login(result.data.authtoken);
            setGlobalState("StudentKey", result.data.data.studentKey);
            setGlobalState("FirstName", result.data.data.firstName);
            setGlobalState("LastName", result.data.data.lastName);
            setGlobalState("FullName", result.data.data.fullName);
            setGlobalState("DistrictID", result.data.data.districtID);
            sessionStorage.setItem("FullName", result.data.data.fullName);
            sessionStorage.setItem("studentkey", result.data.data.studentKey);
            sessionStorage.setItem("districtID", result.data.data.districtID);
            sessionStorage.setItem(
              "DistrictName",
              result.data.data.districtName
            );
            sessionStorage.setItem("authToken", result.data.authtoken);
            if (result.data.data.studentExplorer_LoginAutoComplete) {
              // Save the details for auto-login
              localStorage.setItem("districtId", result.data.data.districtID);
              localStorage.setItem("studentID", result.data.studentId);
              localStorage.setItem("dob", "");
            }
            // sessionStorage.setItem("authenticationToken", result.data.authtoken);
            navigate("/HomeForm", {
              state: JSON.stringify(loginResult),
              DOB: result.data.data.dob,
            });
          } else {
            setSpinner(false);
            setErrorMessage(result.data.errorMsg);
            setUserId(result.data.userId);
            setTenantId(result.data.tenentId);
            setTenant(result.data.tenant);
            setRole(result.data.role);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  
  return (
    <div className="signing-in">
      {(checkURL || fromLogout || code) && (
        <div
          style={{
            border: "2px solid #2D4D93",
            borderRadius: "8px",
            overflow: "hidden",
            width: "100%",
            maxWidth: "700px",
            margin: "20px auto",
            fontFamily: "Arial, sans-serif",
            position: "relative",
          }}
        >
          {/* Header */}
          <div
            style={{
              backgroundColor: "#2D4D93",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              padding: "10px 16px",
            }}
          >
            <img
              src={explorerImg}
              alt="Tango Student Explorer Logo"
              style={{ height: "40px", marginRight: "12px" }}
            />
            <h3 style={{
              margin: 0,
              fontSize: "20px",
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
            }}>Tango Student Explorer</h3>
          </div>

          {/* Message Body */}
          <div
            style={{
              backgroundColor: "#fff",
              color: "#000",
              padding: "16px",
              fontSize: "16px",
              textAlign: "center",
            }}
          >
            {invalidCode && (
              <React.Fragment>
                <h4 style={{ color: "red" }}>Alert : Invalid Code</h4>
                <p><strong>Code:</strong> {code}</p>
              </React.Fragment>
             
            )}

            {fromLogout && (
              <h4>You have successfully been logged out of Tango Student Explorer!</h4>
            )}

            <br />
            <p>
              To sign in with ClassLink click the button below or contact Tango Software Support for assistance.
            </p>
            <br />
            
            <br />
            <a
              href="https://launchpad.classlink.com/oauth2/v2/auth?scope=profile&redirect_uri=https%3A%2F%2Fexplorer.tangosoftware.com%2Fclasslink&client_id=c1744210236732dff7b1d86ef51fc8d6d4b7de8bb6e2&response_type=code"
              target="_blank"
              rel="noopener noreferrer"             
            >
              <img
              src={classLink_Img}
              height={100}
              width={100}
              alt="ClassLink"
              style={{ width: "300px", height:"56px" }}
            />
            </a>
            {!fromLogout && (
              <div style={{ marginTop: "20px", fontSize: "14px" }}>
                <p><strong>Tango Software Support</strong></p>
                <p>Email: <a href="mailto:support@tangosoftware.com">support@tangosoftware.com</a></p>
                <p>Phone: <a href="tel:8889325282">888 932 5282</a></p>                
              </div>
              
            )}
            <Timestamp date={new Date()} />
          </div>
        </div>
      )}

      {userData != null && userData.roleId !== 4 && (
        <div
          style={{
            border: "2px solid #2D4D93",
            borderRadius: "8px",
            overflow: "hidden",
            width: "100%",
            maxWidth: "700px",
            margin: "20px auto",
            fontFamily: "Arial, sans-serif",
            position: "relative",
          }}
        >
          {/* Header */}
          <div
            style={{
              backgroundColor: "#2D4D93",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              padding: "10px 16px",
            }}
          >
            <img
              src={explorerImg}
              alt="Tango Student Explorer Logo"
              style={{ height: "40px", marginRight: "12px" }}
            />
            <h3 style={{
              margin: 0,
              fontSize: "20px",
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
            }}>Tango Student Explorer</h3>
          </div>

          <div
            style={{
              backgroundColor: "#fff",
              color: "#000",
              padding: "16px",
              fontSize: "16px",
              textAlign: "center",
            }}
          >
            <h4 style={{ color: "red" }}>Alert : Invalid Role</h4>
            <br />
            <h4 style={{ marginTop: 0 }}>Successful ClassLink SSO Login Attempt</h4>
            <p><strong>User:</strong> {userData.displayName}</p>
            <p><strong>Role:</strong> {userData.profile}</p>
            <p>
              Only students are allowed to log into Tango Student Explorer. Please contact Tango Software Support for assistance.
            </p>
            <div style={{ marginTop: "20px", fontSize: "14px" }}>
              <p><strong>Tango Software Support</strong></p>
              <p>Email: <a href="mailto:support@tangosoftware.com">support@tangosoftware.com</a></p>
              <p>Phone: <a href="tel:8889325282">888 932 5282</a></p>
            </div>
            <Timestamp date={new Date()} />
          </div>
        </div>
      )}

      {errorMessage && (
        <div
          style={{
            border: "2px solid #2D4D93",
            borderRadius: "8px",
            overflow: "hidden",
            width: "100%",
            maxWidth: "700px",
            margin: "20px auto",
            fontFamily: "Arial, sans-serif",
            position: "relative",
          }}
        >
          <div
            style={{
              backgroundColor: "#2D4D93",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              padding: "10px 16px",
            }}
          >
            <img
              src={explorerImg}
              alt="Tango Student Explorer Logo"
              style={{ height: "40px", marginRight: "12px" }}
            />
            
            <h3 style={{
              margin: 0,
              fontSize: "20px",
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
            }}>Tango Student Explorer</h3>
          
          </div>

          <div
            style={{
              backgroundColor: "#fff",
              color: "#000",
              padding: "16px",
              fontSize: "16px",
              textAlign: "center",
            }}
          >

            <h4 style={{ color: "red" }}>Alert : Invalid Student ID</h4>
            <br/>
              <p>District Name: {tenant}</p>
              <p>Tenant ID: {tenantId}</p>
              <p>User ID: {userId}</p>
              <p>Role: {role}</p>
            {errorMessage.replace(/\.*$/, "")}. Please contact Tango Software Support for assistance.
            <br />
            <div style={{ marginTop: "20px", fontSize: "14px" }}>
              <p><strong>Tango Software Support</strong></p>
              <p>Email: <a href="mailto:support@tangosoftware.com">support@tangosoftware.com</a></p>
              <p>Phone: <a href="tel:8889325282">888 932 5282</a></p>
            </div>
            <Timestamp date={new Date()} />
          </div>
        </div>
      )}
      {spinner && (
        <React.Fragment>
          <span style={{ fontSize: "28px" }}>Signing in...</span>
          <span className="spinner"></span>
        </React.Fragment>
      )}
    </div>
  );
}
